import { useMutation } from '@tanstack/react-query';
import { useAderenciaPrecosStore } from '../AderenciaPrecos.store';
import * as service from '../services';

type FaixaKey = 'acimaMaximo' | 'acimaIdeal' | 'igualIdeal' | 'abaixoIdeal' | 'dentroRange' | 'abaixoMinimo';

interface SerieConfig {
  key: FaixaKey;
  name: string;
  label?: string;
  color: string;
}

const SERIES_CONFIG: Record<'withIgualIdeal' | 'withoutIgualIdeal', SerieConfig[]> = {
  withIgualIdeal: [
    { key: 'acimaMaximo', name: 'Acima do máximo', label: 'Acima do preço máximo', color: '#D53B3B' },
    { key: 'acimaIdeal', name: 'Acima do ideal', label: 'Acima do ideal', color: '#12805C' },
    { key: 'igualIdeal', name: 'Igual ao preço ideal', label: 'Igual ao preço ideal', color: '#0D66D0' },
    { key: 'abaixoIdeal', name: 'Abaixo do ideal', label: 'Abaixo do ideal', color: '#12805C' },
    { key: 'abaixoMinimo', name: 'Abaixo do mínimo', label: 'Abaixo do preço mínimo', color: '#FF8B90' },
  ],
  withoutIgualIdeal: [
    { key: 'acimaMaximo', name: 'Acima do máximo', label: 'Acima do preço máximo', color: '#D53B3B' },
    { key: 'dentroRange', name: 'Dentro do range', label: 'Dentro do range', color: '#12805C' },
    { key: 'abaixoMinimo', name: 'Abaixo do mínimo', label: 'Abaixo do preço mínimo', color: '#FF8B90' },
  ],
};

export const useProductsByRange = () => {
  const { setAderenciaPrecosState } = useAderenciaPrecosStore();

  const getProductsByRange = async data => {
    const res = await service.getAderenciaProductsByRange(data);
    return res;
  };

  const successAction = data => {
    const content = data?.data ?? [];

    const hasIgualIdeal = content.some(item => item.faixas.igualIdeal !== null);
    const config = hasIgualIdeal ? SERIES_CONFIG.withIgualIdeal : SERIES_CONFIG.withoutIgualIdeal;

    const chartData = config.map(serie => ({
      name: serie.name,
      color: serie.color,
      data: content.map(item => ({
        x: new Date(item.data).getTime(),
        y: item.faixas[serie.key]?.porcentagem || 0,
        value: item.faixas[serie.key]?.valor || 0,
      })),
    }));

    const removeZeroData = chartData.map(item => ({
      ...item,
      data: item.data.map(point => ({
        ...point,
        y: point.y === 0 ? null : point.y,
      })),
    }));

    setAderenciaPrecosState('aderenciaProductByRangeData', removeZeroData);
  };

  const mutate = useMutation({
    mutationFn: getProductsByRange,
    onSuccess: data => successAction(data),
  });

  return {
    isLoadingProductByRange: mutate.isPending,
    handleRequestProductByRange: mutate.mutateAsync,
  };
};
